import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { Col, Row, Button, Radio, Icon, Spin, Tabs } from 'antd';
import { withTranslation, WithTranslation } from 'react-i18next'
import { withIdentity, IdentityProps } from '../../../../core/services/authentication';
import { WhatsNewReportStore } from '../../../../stores/whats-new-store'
import { connect } from 'redux-scaffolding-ts';
import WhatsNewReportEditView from './whats-new-report-editor';
import {withUserProfile} from "../../../../components/user-profile";

interface WhatsNewReportViewProps extends RouteComponentProps, WithTranslation, IdentityProps {

}

interface WhatsNewReportViewState {
    isBusy: boolean
}


@connect(['whatsNewReports', WhatsNewReportStore])
class WhatsNewReportTabView extends React.Component<WhatsNewReportViewProps, WhatsNewReportViewState> {
    private get whatsNewReportsStore() {
        return (this.props as any).whatsNewReports as WhatsNewReportStore;
    }

    constructor(props: WhatsNewReportViewProps) {
        super(props);
        this.state = {
            isBusy: false,
        }
    }

    public render() {
        const { t } = this.props;
        return <Spin spinning={this.state.isBusy}>
            <div>
                <Tabs tabPosition={"left"}>
                    <Tabs.TabPane key="en" tab={t("English")}>
                        <WhatsNewReportEditView language={"en"}/> 
                    </Tabs.TabPane>
                    <Tabs.TabPane key="es" tab={t("Spanish")}>
                        <WhatsNewReportEditView language={"es"}/> 
                    </Tabs.TabPane>
                    <Tabs.TabPane key="pt" tab={t("Portuguese")}>
                        <WhatsNewReportEditView language={"pt"}/> 
                    </Tabs.TabPane>
                    <Tabs.TabPane key="fr" tab={t("French")}>
                        <WhatsNewReportEditView language={"fr"}/> 
                    </Tabs.TabPane>
                </Tabs>
            </div>
        </Spin>
    }
}
export default withUserProfile(withIdentity(withRouter(withTranslation()(WhatsNewReportTabView as any) as any) as any)) as any
